//API Method Constants
export const METHOD_LIST = '/exportdatpah/list/';
export const METHOD_DOWNLOAD_ZIP = '/exportdatpah/downloadzip/';

//ZIP Download related Info
export const ZIP_ENABLED_PRODUCTS=[3,6,7,10,13,55];
export const ALLOWED_USERS= ['INTUSER']


